import React from 'react'

import css from '@styled-system/css'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconBase, { Path } from '@/components/IconBase'

const TooltipArrowStyles = styled(IconBase)(({ $direction }) => {
  const directions = {
    up: 0,
    right: 90,
    down: 180,
    left: 270,
  }

  return css({
    alignItems: 'flex-end',
    svg: {
      transform: `rotate(${directions[$direction]}deg)`,
    },
  })
})

const TooltipArrow = ({ color = 'white', direction = 'up', outlineColor = '#E4EDF6', ...props }) => {
  return (
    <TooltipArrowStyles
      $direction={direction}
      size='lg'
      viewBox='0 0 40 12'
      zindex={8005}
      {...props}
    >
      <Path
        d='
        M18.3646 4.21814
        C19.7266 2.68842 22.2734 2.68842 23.6354 4.21814
        C27.2075 8.23019 33.9534 14.6126 41 15
        L1 15C8.04657 14.6126 14.7925 8.23018 18.3646 4.21814
        Z
      '
      />
      <Path
        d='
        M41 14
        C33.9534 13.6126 27.2075 7.23019 23.6354 3.21814
        C22.2734 1.68842 19.7266 1.68842 18.3646 3.21814
        C14.7925 7.23018 8.04657 13.6126 1 14
      '
        fill={color}
        stroke={outlineColor}
        strokeWidth='1.4'
      />
    </TooltipArrowStyles>
  )
}

TooltipArrow.propTypes = {
  color: PropTypes.string,
  direction: PropTypes.string,
  outlineColor: PropTypes.string,
}

export default TooltipArrow
